export default "__VITE_ASSET__BdBL9mOf__"